import React, { useEffect, useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Chip from '@material-ui/core/Chip';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => ({
  chip: {
    backgroundColor: theme.palette.background.yellow,
    clear: 'both',
    float: 'left',
    marginTop: 10,
  },
}));

export default function PeerStatus(props) {
  const classes = useStyles();
  if( props.finished ) {
    return (<Chip onClick={props.leaveChat} onDelete={props.leaveChat} className={classes.chip} label='Chat session finished. Please click here to close chat.'></Chip>);
  }

  if( !props.status ) {
    return (<Typography style={{clear:'both', float:'left', marginTop: 3}} variant='caption'>&nbsp;</Typography>);
  }

  let name = props.rep ? `${props.rep.first_name} ${props.rep.last_name}` : props.peer.name;
  if( props.status == 'typing' ) {
    return <Typography style={{clear:'both', float:'left', marginTop: 3}} variant='caption'>{`${name} is typing...`}</Typography>
  }
  if( props.status == 'offline' ) {
    return <Typography style={{clear:'both', float:'left', marginTop: 3}} variant='caption'>{`${name} has left the chat.`}</Typography>
  }
}
